import { render, staticRenderFns } from "./note.vue?vue&type=template&id=2355f000&scoped=true"
import script from "./note.vue?vue&type=script&lang=js"
export * from "./note.vue?vue&type=script&lang=js"
import style0 from "./note.vue?vue&type=style&index=0&id=2355f000&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2355f000",
  null
  
)

export default component.exports